import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../icons/SvgIcon';

const ArrowButton = (props) => {
  const {
    className, style, onClick, direction,
  } = props;

  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
      role="button"
      aria-hidden="true"
    >
      {
                (direction === 'previous')
                  ? <SvgIcon icon="ChevronRightIcon" className="icon-left" />
                  : <SvgIcon icon="ChevronRightIcon" className="icon-right" />
                }
    </div>
  );
};

ArrowButton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  direction: PropTypes.string,
};

export default ArrowButton;
